import $ from 'jquery';

import { APV_ENDPOINT, IAM_ENDPOINT } from './constants';
import { getSha256Hashed } from './crypto';
import { spinnerStart, spinnerStop } from './utils/spinner';

export const initConpay = async (userKey) => {
  return new Promise((resolve, reject) => {
    $.get({
      url: `${IAM_ENDPOINT}/api/v1/iam/initConpay?userKey=${userKey}`,
      contentType: 'application/json',
      headers: {
        'user-key': getSha256Hashed(userKey),
      },
      dataType: 'json',
    })
      .done((data, _, jqXHR) => {
        if (data.success) {
          const issueApiKey = jqXHR.getResponseHeader('Authorization');
          sessionStorage.setItem('CONPAY_ISSUE_API_KEY', issueApiKey);
          resolve('');
        } else {
          reject(data);
        }
      })
      .fail((e) => {
        // reject('커넥트페이 토큰 발급 실패');
        reject(e);
      });
  });
};

export const getAccessToken = async () => {
  return new Promise((resolve, reject) => {
    const userKey = sessionStorage.getItem('CONPAY_USER_KEY');
    const callbackUrl = sessionStorage.getItem('CONPAY_REDIRECT_URL');
    const issueApiKey = sessionStorage.getItem('CONPAY_ISSUE_API_KEY');

    $.get({
      url: `${IAM_ENDPOINT}/api/v1/iam/accessTokenSdk?userKey=${userKey}&callbackUrl=${callbackUrl}`,
      contentType: 'application/json',
      dataType: 'json',
      headers: {
        Authorization: issueApiKey,
      },
    })
      .done((data, _, jqXHR) => {
        if (data.success) {
          const apiKey = jqXHR.getResponseHeader('Authorization');
          sessionStorage.setItem('CONPAY_API_KEY', apiKey);
          resolve('');
        } else {
          reject(data);
        }
      })
      .fail((e) => {
        reject(e);
        // reject('커넥트페이 토큰 발급 실패');
      });
  });
};

// // 승인계 getAccessToken
// export const getAccessToken = async () => {
//   const brandInfo = JSON.parse(sessionStorage.getItem('CONPAY_BRAND_INFO'));
//   const userKey = sessionStorage.getItem('CONPAY_USER_KEY');
//   const redirectUrl = sessionStorage.getItem('CONPAY_REDIRECT_URL');

//   return new Promise((resolve, reject) => {
//     if (brandInfo == null || userKey == null || redirectUrl == null) {
//       reject('안전한 결제을 위해 다시 시도해 주세요.');
//     }

//     $.get({
//       url: `${IAM_ENDPOINT}/api/v1/iam/accessToken?userKey=${userKey}&callBack=${redirectUrl}`,
//       contentType: 'application/json',
//       dataType: 'json',
//     })
//       .done((data, _, jqXHR) => {
//         if (data.success) {
//           const apiKey = jqXHR.getResponseHeader('Authorization');
//           sessionStorage.setItem('CONPAY_API_KEY', apiKey);
//           resolve('');
//         } else {
//           reject(data);
//         }
//       })
//       .fail((e) => {
//         reject('커넥트페이 토큰 발급 실패');
//       });
//   });
// };

// 승인 API
export const postBrandAprv = async (aprvUrl, aprvData) => {
  const apiKey = sessionStorage.getItem('CONPAY_API_KEY');

  return new Promise((resolve, reject) => {
    $.post({
      url: aprvUrl,
      headers: {
        Authorization: apiKey,
      },
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(aprvData),
      beforeSend: () => {
        spinnerStart();
      },
    })
      .done((data) => {
        resolve(data);
      })
      .fail((e) => {
        reject(e.responseJSON);
      })
      .always(() => {
        spinnerStop();
      });
  });
};

// GET conpay-api iam without token
export const getIam = (url) => {
  return new Promise((resolve, reject) => {
    $.get({
      url: `${IAM_ENDPOINT}/api/v1/iam/${url}`,
      dataType: 'json',
      beforeSend: () => {
        spinnerStart();
      },
    })
      .done((data) => {
        if (data.resultCode != '200') {
          reject(data);
        }
        resolve(data);
      })
      .fail((e) => {
        reject(e.responseJSON);
      })
      .always(() => {
        spinnerStop();
      });
  });
};

// POST conpay-api iam without token
export const postIam = (url, data) => {
  return new Promise((resolve, reject) => {
    $.post({
      url: `${IAM_ENDPOINT}/api/v1/iam/${url}`,
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
      beforeSend: () => {
        spinnerStart();
      },
    })
      .done((data) => {
        if (data.resultCode != '200') {
          reject(data);
        }
        resolve(data);
      })
      .fail((e) => {
        reject(e.responseJSON);
      })
      .always(() => {
        spinnerStop();
      });
  });
};

// GET conpay-api apv pub (without token)
export const getApvPub = (url, cache = true) => {
  return new Promise((resolve, reject) => {
    $.get({
      url: `${APV_ENDPOINT}/api/v1/apv/pub/${url}`,
      contentType: 'application/json',
      dataType: 'json',
      cache,
    })
      .done((data) => {
        if (data.resultCode != '200') {
          reject(data);
        }
        resolve(data.resultData);
      })
      .fail((e) => {
        reject(e.responseJSON);
      });
  });
};

// GET conpay-api apv
export const getApv = (url, cache = true, useSpinner = true) => {
  const apiKey = sessionStorage.getItem('CONPAY_API_KEY');

  return new Promise((resolve, reject) => {
    $.get({
      url: `${APV_ENDPOINT}/api/v1/apv/app/${url}`,
      headers: {
        Authorization: apiKey,
      },
      contentType: 'application/json',
      dataType: 'json',
      cache,
      beforeSend: () => {
        useSpinner && spinnerStart();
      },
    })
      .done((data) => {
        if (data.resultCode != '200') {
          reject(data);
        }
        resolve(data.resultData);
      })
      .fail((e) => {
        reject(e.responseJSON);
      })
      .always(() => {
        useSpinner && spinnerStop();
      });
  });
};

// POST conpay-api apv
export const postApv = (url, data) => {
  const apiKey = sessionStorage.getItem('CONPAY_API_KEY');

  return new Promise((resolve, reject) => {
    $.post({
      url: `${APV_ENDPOINT}/api/v1/apv/app/${url}`,
      headers: {
        Authorization: apiKey,
      },
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(data),
      beforeSend: () => {
        spinnerStart();
      },
    })
      .done((data) => {
        if (data.resultCode != '200') {
          reject(data);
        }
        resolve(data.resultData);
      })
      .fail((e) => {
        reject(e.responseJSON);
      })
      .always(() => {
        spinnerStop();
      });
  });
};
